/* eslint-disable */

export const enum Priority {
  highest = 1,
  higher = 2,
  medium = 3,
  lower = 4,
  lowest = 5,
}
